export default __webpack_public_path__ + "static/media/6.b7700102.jpg";